<section class="tnq-banner section-pd">
    <div class="d-xl-block d-none nit-banner">
        <img src="assets/images/case-study/nit-banner.png" alt="NIT - 文法 チェック" />
    </div>
    <div class="container">
        <div class="row">
            <div class="col-xl-8">
                <!-- <span class="caseStudy">Case Study</span> -->
                <div class="tnq-logo">
                    <span>
                        <img src="assets/images/case-study/nit.svg" height="45px" alt="nit logo - 英文校正" />
                    </span>
                    <span>
                        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.4648 4.5H8.33984V0.375C8.33984 0.275544 8.30034 0.180161 8.23001 0.109835C8.15968 0.0395088 8.0643 0 7.96484 0L5.71484 0C5.61539 0 5.52 0.0395088 5.44968 0.109835C5.37935 0.180161 5.33984 0.275544 5.33984 0.375V4.5H1.21484C1.11539 4.5 1.02 4.53951 0.949679 4.60984C0.879353 4.68016 0.839844 4.77554 0.839844 4.875L0.839844 7.125C0.839844 7.22446 0.879353 7.31984 0.949679 7.39017C1.02 7.46049 1.11539 7.5 1.21484 7.5H5.33984V11.625C5.33984 11.7245 5.37935 11.8198 5.44968 11.8902C5.52 11.9605 5.61539 12 5.71484 12H7.96484C8.0643 12 8.15968 11.9605 8.23001 11.8902C8.30034 11.8198 8.33984 11.7245 8.33984 11.625V7.5H12.4648C12.5643 7.5 12.6597 7.46049 12.73 7.39017C12.8003 7.31984 12.8398 7.22446 12.8398 7.125V4.875C12.8398 4.77554 12.8003 4.68016 12.73 4.60984C12.6597 4.53951 12.5643 4.5 12.4648 4.5Z" fill="black"/>
                        </svg>
                    </span>
                    <span>
                        <img src="assets/images/trinka_logo.svg" height="45px" alt="trinka logo - 英文チ ェッカー" />
                    </span>
                </div>
                <h1>日本工業大学様　<br/>
                    学術英語執筆スキル向上のため<br class="d-md-block d-none"/>Trinkaを導入</h1>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm key-benefits">
    <div class="trinka_container">
        <div class="row align-items-center">
            <div class="col-lg-4 col-md-12">
                <h5 class="mb-0 text-white">日本工業大学様について</h5>
            </div>
            <div class="col-md-8">
                <div class="key-content white-line">
                    <h6>1907年に前身の東京工科学校が創立した日本工業大学は、日本国内では特に長い歴史を持つ工学系の大学で、「実工学の理念にもとづく工学教育と先進的研究により、新たな価値創造と科学技術の発展に寄与する」という理念のもとに教育・研究活動を行っています。工学・建築の知識の習得を志すおよそ4,000名の学生が在籍しています。</h6>
                    <small class="text-white">(参照元：https://www.nit.ac.jp/ 参照日：2024年7月24日)</small>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2" style="padding: 0;">
                        <p>日本工業大学英語学習サポートセンター（English Learning Support Center: ELSC）様にて、学生および教職員の皆様の学術英語執筆スキルアップのサポートを目的として、Trinka（トリンカ）を導入いただきました。</p>
                        <p>所属する学生・教職員の方の英語力向上のために設立された同センターでは、現在ではTOEIC強化プログラムや、工学に特化した英語学習など、世界に通用するエンジニアに必要な英語力を養成するための学習サポートを提供されています。</p>
                        <p>英文校正会社エナゴが開発したAIによる英文ライティングアシスタント機能に信頼をいただき、学内の英語での論文執筆スキルをさらに高め、国際的な学術ジャーナルでの論文掲載数を増やすことをねらいとしてTrinkaを導入いただきました。</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <img src="assets/images/case-study/nit-team.jpg" alt="nit team - ai英文校正" class="img-fluid" />
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>

<section class="">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="challenges-section">
                    <div class="trinka-title">
                        <h2>お客様が抱えていた課題</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    </div>
                    <div class="row match-box">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12 dflex">
                            <div class="c-card nit-card">
                                <p>ELSC在籍の英語ネイティブ講師の皆様は理工系の研究者ではなく、一方、所属する理工系の研究者・教員の皆様は英語のネイティブではないため、学生たちに「いかにして理工系の英語を教えるか」が同センターの課題でした。</p>
                                <span class="bold">1</span>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12 dflex">
                            <div class="c-card nit-card">
                                <p>英語ネイティブ講師の皆様と学生・教員の皆様とが活発に交流できる場所として、ELSCの学内での認知度をさらに向上させる施策をお探しでした。</p>
                                <span class="bold">2</span>
                            </div>
                        </div>
                        <!-- <div class="col-lg-4 col-md-3 col-sm-6 col-12 dflex">
                            <div class="c-card nit-card">
                                <p>They aimed to <b>increase the number of their international publications</b> and presentations by encouraging their professors and students to write more in English.</p>
                                <span class="bold">3</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="trinka-title text-center mb-0">
                    <h2 class="text-center">Trinkaが提供したソリューション</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>同校の課題や目指すところについてお伺いした上で、ELSCを利用する学生・教職員の皆様が無制限にTrinkaの文法チェックをお使いいただけるプランをご提案しました。</p>
                </div>
            </div>
            <div class="result-section">
                <div class="row match-box no-margin ">
                    <div class="col-lg-4 col-md-5 col-12 dflex no-gutter">
                        <div class="c-card result-left justify-content-center">
                            <svg width="42" height="38" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M41.1667 17.3333C41.1667 16.3609 40.7804 15.4282 40.0927 14.7406C39.4051 14.053 38.4725 13.6667 37.5 13.6667H25.9133L27.6733 5.28833C27.71 5.105 27.7283 4.90333 27.7283 4.70166C27.7283 3.94999 27.4167 3.25333 26.9217 2.75833L24.9783 0.833328L12.915 12.8967C12.2367 13.575 11.8333 14.4917 11.8333 15.5V33.8333C11.8333 34.8058 12.2197 35.7384 12.9073 36.4261C13.5949 37.1137 14.5275 37.5 15.5 37.5H32C33.5217 37.5 34.8233 36.5833 35.3733 35.2633L40.91 22.3383C41.075 21.9167 41.1667 21.4767 41.1667 21V17.3333ZM0.833344 37.5H8.16668V15.5H0.833344V37.5Z" fill="white"/>
                            </svg>
                            <p>学生・教員の皆様にTrinkaを英語論文執筆の動機付けとしていただけたほか、Trinkaが提案する修正を、英語ネイティブ講師の方々にも理工系の英文ルールの参考としていただくことができました。</p>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-7 col-12 dflex no-gutter">
                        <div class="c-card result-right justify-content-center">
                            <ul>
                                <li>英語ネイティブ講師の皆様とTrinkaとのダブルチェックによる英語論文の精度向上</li>
                                <li>各ユーザーのPCのMS-WORD上で修正履歴をじっくりと確認できることが、学生の英語学習に高い効果</li>
                                <li>Trinkaの導入が、所属する学生・教員の皆様によるELSCの利用やネイティブ講師の皆様との英語での会話のきっかけに</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="result-section">
                <div class="row match-box no-margin ">
                    <div class="col-lg-4 col-md-5 col-12 dflex no-gutter">
                        <div class="c-card result-left justify-content-center">
                            <svg width="42" height="38" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M41.1667 17.3333C41.1667 16.3609 40.7804 15.4282 40.0927 14.7406C39.4051 14.053 38.4725 13.6667 37.5 13.6667H25.9133L27.6733 5.28833C27.71 5.105 27.7283 4.90333 27.7283 4.70166C27.7283 3.94999 27.4167 3.25333 26.9217 2.75833L24.9783 0.833328L12.915 12.8967C12.2367 13.575 11.8333 14.4917 11.8333 15.5V33.8333C11.8333 34.8058 12.2197 35.7384 12.9073 36.4261C13.5949 37.1137 14.5275 37.5 15.5 37.5H32C33.5217 37.5 34.8233 36.5833 35.3733 35.2633L40.91 22.3383C41.075 21.9167 41.1667 21.4767 41.1667 21V17.3333ZM0.833344 37.5H8.16668V15.5H0.833344V37.5Z" fill="white"/>
                            </svg>
                            <p>また、Trinkaの様々な機能は、研究論文を活発に執筆されている教員・研究者の皆様にもお役立ていただいています。</p>
                        </div>
                    </div>
                    <div class="col-lg-8 col-md-7 col-12 dflex no-gutter">
                        <div class="c-card result-right justify-content-center">
                            <ul>
                                <li>引用チェッカー、投稿先ジャーナルへの適合性のチェックなどによる論文投稿作業の迅速化</li>
                                <li>盗用・剽窃チェック機能による、自己剽窃を含む盗用・剽窃の回避</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pt-0">
    <div class="trinka_container">
        <div class="row">
            <div class="col-12">
                <div class="challenges-section">
                    <div class="trinka-title">
                        <h2>サービス導入による相乗効果</h2>
                        <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                    </div>
                    <div class="row match-box">
                        <div class="col-lg-12 col-12 dflex">
                            <div class="c-card nit-card" style="padding-bottom: 15px;">
                                <p class="mb-0">学術英語に特化して開発されたTrinkaを導入いただいたことにより、個別の英語論文の品質だけでなく、所属する学生と研究者の論文執筆のモチベーションや作業効率、ライティングと会話を含めた英語力、さらにはネイティブ教員による英語指導にまで相乗的な効果がもたらされたと、ご担当者様よりお喜びの声をいただきました。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="collaborate-stm section-pd">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title text-center">
                    <h2>ELSCセンター長 桑原拓也様からのご感想</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-md-5">
                <div class="feedback-img">
                    <img src="assets/images/case-study/takuya-kuwahara.png" alt="takuya-kuwahara" class="img-fluid" />
                </div>
            </div>
            <div class="col-md-7 offset-lg-1 col-lg-6">
                <div class="review-statement">
                   <p>日本工業大学 基幹工学部 機械工学科 教授<br/>
                    日本工業大学 英語学習サポートセンター長</p>
                    <div class="inCollab">
                        <div class="review-by">
                            <h6>桑原 拓也 様</h6>
                            <small>博士（工学）、Ph.D.（応用数学）</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="nitQnASection section-pd pb-0">
        <div class="trinka_container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="nitQnA">
                        <h5>Trinkaは貴学において学生の英語学習にどのように役立っていますか？</h5>
                        <p>本学の英語学習サポートセンター（ELSC）にて、主に学術論文や講演論文の添削に利用しています。当センターにはネイティヴ講師が所属していますが、理工系の研究者ではありません。一方で、学科所属の理工系の専任教員や研究者は英語ネイティヴではないというジレンマがありました。どのように理工系の英語を教えるかが当センターの課題でした。そこで出会ったのがTrinkaです。Trinkaの専門分野に合わせた英文校正に加えて、ネイティヴ講師のダブルチェックで、論文の完成度を高めています。ネイティヴ講師もTrinkaによる英文校正から理工系の英文の書き方やルールを学ぶことも多いです。ネイティヴ講師が校正した原稿について学生にアドバイスすることにより、学生の理工系の英語の学習に役立っています。</p>
                    </div>
                    <div class="nitQnA">
                        <h5>Trinkaが（学生にとって、または教員にとって）使いやすいと感じる点を教えてください。</h5>
                        <p>最もTrinkaが使いやすい点として、MS-WORDの校閲機能を利用していることです。まず、原稿を自分のPCに保管できることが挙げられます。他社の英文校正ツールはWeb上で修正を反映させる作業が必要なツールが多いですが、やはり自分の手元でゆっくりと確認できることは、使い勝手が良く、重要です。原稿をタブレットなどの他のデバイスに移すこともできるので、好きな時間に自分が書いた英語の間違いを注意深く見直すことができ、英語学習の観点からも大変良いと感じています。Trinkaを導入するに当たっては、他の英文校正ツールも併せて、工学の専任教員と当センターのネイティヴ講師が試用して、導入を決定しました。Trinkaは理工学の観点からも、英語の観点からも質の高い英文校正ができることを実感しています。</p>
                    </div>
                    <div class="nitQnA">
                        <h5>Trinka内の諸機能のうち、特に便利だと感じている機能は何ですか？</h5>
                        <p>上述の通り、TrinkaがMS-WORDの校閲機能を利用している点です。校正後にサマリー（Revision Summary）が表示されることも英語学習に役立ちます。参考文献のチェック機能（Citation Checker）、参考文献のサーチ機能（Journal Finder）などの機能も大変便利です。特に便利だと感じているのは、剽窃チェッカー（Plagiarism Checker）です。自分で書いた過去の文献に引っかかることがあります。自分の一連の研究である場合は、自分のスタイルがあるので、意図せずに剽窃に引っかかる傾向があります。剽窃チェッカーを利用するとそのような剽窃のリスクを低減できます。また、翻訳ツールを使って、英文を作成すると、AIが生成した英文と認識することが分かりました。多くの出版社も同様のチェッカーを利用していると思うので、投稿前にこのようなチェックを行えることは、研究倫理の点からも大変助かります。</p>
                    </div>
                    <div class="nitQnA">
                        <h5>ELSC内部または貴学全体において、論文執筆にTrinkaが役立った/役立っている場面はありますか？</h5>
                        <p>Trinkaは学術論文や講演論文の執筆に大いに役立っています。AIが添削するので、人の目では見逃してしまうミスもチェックされ、英語に関しては、論文執筆における安心感も得られます。英語のニュアンスや冠詞の使い方、そもそもの英単語の使い方が間違っている点などは、ネイティヴ講師がチェックしています。Trinkaを使用することで、ネイティヴ講師の英文校正作業の効率も大幅にアップしています。ただし、特に査読付きの論文に関しては、最終的にはエナゴさんなどの外部の英文校正を利用することを強く推奨しています。Trinkaの導入を機に、学生のみならず、教員の中でも英語で論文を書いてみようという方が増えました。興味をもった教員や学生からのTrinkaに関する問い合わせも多いです。</p>
                    </div>
                    <div class="nitQnA">
                        <h5>Trinkaがもたらした具体的な成功事例、もしくは数値的な成果があれば教えてください。</h5>
                        <p>論文は永遠に残るため、英文にミスがあっても永遠に残ります。日本語の論文でも概要は英語で書くため、気軽に使えるTrinkaは使い勝手が良く、利用者も増えています。また、修士論文の英語の要旨執筆にも利用されています。Trinkaの導入により、当センターを知ってもらい、利用を促すことにも成功しています。これまで当センターに足を踏み入れることのなかった学生も当センターを利用し、ネイティヴ講師と英語で会話する機会が増えてきました。教員や学生が研究業績を増やすことにも貢献しています。導入してから6カ月間の利用者は20人を超えていますが、さらに利用者数を増やすことを目標にしています。</p>
                    </div>
                    <div class="nitQnA">
                        <h5>弊社社員やサポート窓口の対応はいかがでしたか？</h5>
                        <p>御社のご対応やサポートに大変満足しています。打合せやディスカッションを行う機会も設けていただいているので、Trinkaのフィードバックもできています。さらに、理工系の英語教育の課題解決に向けた情報共有もできているので、感謝しております。御社のウェビナーやイベントの情報もいただけることも嬉しいです。日本では、研究室の指導教員から論文執筆の方法を伝授する伝統が残っており、理工系の英語教育がそれほど進んでいないのが現状です。一方で、論文執筆に関する規則や倫理は年々厳しくなってきています。いわば伝統的な師匠から弟子への理工学英語教育では、カバーできなくなっているのも事実です。当センターは、理工系の英語教育のパイオニアとなるべく邁進する所存ですので、今後も御社のサポートを賜ればと存じます。</p>
                    </div>
                    <div class="nitQnA">
                        <h5>他の英文校正ツールと比べて、Trinkaを導入することのメリットは何だとお考えですか？</h5>
                        <p>MS-WORDの校閲機能を利用しているので、英文校正会社から英文校正を受けているのと同じ感覚で利用できます。外部の英文校正を利用したことがある方は、Trinkaを利用することに違和感はないのではと思います。何より、Trinkaは英文校正に定評があるエナゴさんが開発したツールということへの信頼と安心感があります。これらの点はTrinkaを導入することのメリットであると考えています。その他のTrinkaを導入することのメリットとしては、繰り返しになりますが、教員や学生の研究業績への貢献、当センターを利用する動機にもなっています。英文校正がネイティヴ講師と会話する話題づくりにもなっています。自分の研究に関することだと英語で話しやすいという学生も多いです。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container">
        <div class="row justify-content-center">
            <div class="col-md-10 col-lg-8">
                <div class="trinka-title text-center">
                    <h3 class="text-white">Trinkaで、英語での研究発信力の強化を</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button style="margin: 0; padding: 0;" id="salesContactButtons" data-toggle="modal"
                    data-target="#EnterPriseContactPopup" class="white-btn" type="submit">お問い合わせ</button>
                </div>
            </div>
        </div>  
    </div>
</section>

<app-enterprise-modal></app-enterprise-modal>>